import { sendEmail } from '../../lib/api/send-email'
import type { SendEmailInput } from '../../lib/types/models/mail/create-mail-attachment'
import { API } from '../apis.config'

export const sendEmailToEnrollments = (input: SendEmailInput) => {
  return sendEmail(API.enrollments.sendEmail.url, input)
}
